export enum MFA_SETUP_STATE {
	ON,
	OFF,
	INITIATED,
	WAITING_FOR_TOTP,
}
